// Angular
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Adm000Service } from '../../../../core/_base/_service/adm000.service';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit { 
	Count:number=0;
	showBackButton:boolean=false;
	  constructor(
		private objAdm000Service:Adm000Service,
		private changeDetectorRef: ChangeDetectorRef,
		private router: Router,
		private route: ActivatedRoute
	  ) { }
  ngOnInit() {
		const url = window.location.href;

  // Extract moduleId from URL
  const moduleId = this.getModuleIdFromUrl(url);
  if(moduleId!=null){
	this.showBackButton=true;
  }
  }
	GoToWidgetDashBoard(){
		//localStorage.clear();
		//this.router.navigate(['/#/widget']);
		
	    this.objAdm000Service.GetModules().subscribe(dataAdm0000=>{
		this.Count=dataAdm0000.Count;

		if(this.Count==0){
		this.router.navigate(['widget/widget-dashboard/3']);
		this.changeDetectorRef.detectChanges();
		
		}
		else{
		this.router.navigate(['/widget/landing']);
		this.changeDetectorRef.detectChanges();

		}
		this.changeDetectorRef.detectChanges();
	})
	
		// window.location.href='/#/widget';
	}
	GoBack(){

		const url = window.location.href;

  // Extract moduleId from URL
  const moduleId = this.getModuleIdFromUrl(url);

  // If moduleId is 105 or 106 → redirect
  if (moduleId === 105 || moduleId === 106 || moduleId==107 || moduleId==108 || moduleId==109 || moduleId==110 || moduleId==111 || moduleId==112 || moduleId==126 || moduleId==127 || moduleId==128 || moduleId==129 || moduleId==130) {
   this.router.navigate(['widget/widget-dashboard/3']);
    return;
  }
  if(moduleId==117){
	this.router.navigate(['widget/widget-dashboard/2']);
    return;
  }
    if (moduleId === 118 || moduleId === 119 || moduleId==120 || moduleId==121 || moduleId==122 || moduleId==123) {
   this.router.navigate(['widget/widget-dashboard/1']);
    return;
  }

  // Otherwise normal back
  window.history.back();

	}
	getModuleIdFromUrl(url: string): number | null {
  try {
    const paramsString = url.split('?')[1]; // take part after ?
    if (!paramsString) return null;

    const params = new URLSearchParams(paramsString);

    const moduleId = params.get('moduleId');
    return moduleId ? Number(moduleId) : null;
  } catch {
    return null;
  }
}
}

